import { render, staticRenderFns } from "./positioning-device-fitting.vue?vue&type=template&id=6f3ca7ce&scoped=true"
import script from "./positioning-device-fitting.vue?vue&type=script&lang=js"
export * from "./positioning-device-fitting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3ca7ce",
  null
  
)

export default component.exports